import { IEntity, IPagedSearchParams } from '@pf/shared-common';
import {
    ContainerFragment,
    InventoryBundleFragment,
    PutAwayViewModelCreateBody,
    PutAwayViewModelRead,
    SlotFragment,
} from '@control-tower/platform-wms';
import { IUserFragment } from '@pf/shared/util-platform';

export type PutAwayRead = PutAwayViewModelRead & IEntity;
export type PutAwayCreate = PutAwayViewModelCreateBody;
export interface PutAwaySearchParams extends IPagedSearchParams {
    putAwayListId: string;
    search?: string;
}

export class PutAwayDto implements IEntity {
    constructor(data: Partial<PutAwayDto>) {
        Object.assign(this, data);
    }

    id!: string;
    putAwayByUser?: IUserFragment | null;
    putAwayListId?: string;
    inventoryBundle?: InventoryBundleFragment;
    container?: ContainerFragment & {
        inventoryBundles?: InventoryBundleFragment[];
    };
    putAwayToSlot?: SlotFragment;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
}
